const UiRadioPropsOption = {
  modelValue: { type: String, default: "" },
  value: { required: true }
};
const UiRadioEmits = {
  "change": (_ev) => true,
  "update:modelValue": (_data) => true
};

export { UiRadioEmits, UiRadioPropsOption };
//# sourceMappingURL=index.mjs.map
